import { module } from 'stereomodularjs';
import '@stereoweb/lite-youtube-stereo';
import '@stereoweb/lite-vimeo-stereo';
// import Plyr from 'plyr';

export default class extends module {
    constructor(m) {
        super(m);
        // this.events = {
        //     click: 'toggle'
        // }
    }

    async init(attr = null) {
        if (this.el && this.el.dataset.plyrEmbedId && this.el.dataset.plyrEmbedId == '000') {
            return;
        }
        if(!attr){
            let thisEl = this.el;
            
            let transcriptItems = false;
            // Create sub element to init Plyr since it destroy the element he's binded to
            // let thisPlyrWrapper = thisEl.querySelector('.js-plyr-wrapper');

            // // set default source
            // let currentSource = {
            //     type: 'video',
            //     sources: [
            //         {
            //         src: thisEl.getAttribute('data-plyr-embed-id'),
            //         provider: thisEl.getAttribute('data-plyr-provider'),
            //         },
            //     ],
            // }

            // if(thisPlyrWrapper){
            //     // init Plyr
            //     this.videoPlayer = new Plyr(thisPlyrWrapper, { 
            //         autoplay: false,
            //         youtube: { noCookie: false, rel: 0, showinfo: 0, iv_load_policy: 1, controls: 0},
            //     });
            //     // Add source
            //     this.videoPlayer.source = currentSource;
            // }
           
            // enable transcription if it exists
            let videoWrapper = thisEl.closest('.js-video-player__wrap');
            let videoTranscript = thisEl.querySelector('.js-video-player__transcript');
            if(videoWrapper){
                transcriptItems = videoWrapper.querySelectorAll('.js-video-player__transcript .js-video-transcript__item');
                // this.videoPlayer.on('timeupdate', event => {
                //     this.updateTranscription(event.detail.plyr.currentTime, transcriptItems, videoWrapper);
                // });
            }
        }
    } catch(error) {
        console.error('Error loading Plyr:', error);
    }

    updateTranscription(currentTime, transcriptItems, thisWrapper) {
        // Get the transcript scroller element
        const transcriptScroller = thisWrapper.querySelector('.o-video-transcript__scroll');

        // Iterate through transcript items
        transcriptItems.forEach((timeEntry, index) => {
            // Extract time information
            let time = timeEntry.getAttribute('data-time').split(':');
            let seconds = (parseInt(time[0]) * 60) + parseInt(time[1]);

            // Check if the current time is after the time of the transcript entry
            if (seconds < currentTime) {
                let nextTranscript = transcriptItems[index+1];
                if(nextTranscript == undefined){
                    nextTranscript = transcriptItems[index];
                }
                let nextTime = nextTranscript.getAttribute('data-time').split(':');
                let nextSeconds = (parseInt(nextTime[0]) * 60) + parseInt(nextTime[1]);

                if (nextSeconds > currentTime) {
                    timeEntry.classList.add('is-active');
                    this.smoothScrollTo(transcriptScroller, timeEntry.offsetTop - 40, 200);
                }else{
                    if(index < transcriptItems.length - 1){
                        timeEntry.classList.remove('is-active'); 
                    }else{
                        transcriptItems[transcriptItems.length - 1].classList.add('is-active'); 
                    }
                }
            }else{
                if(index < transcriptItems.length - 1){
                    timeEntry.classList.remove('is-active'); 
                }
            }
        });
    }

    smoothScrollTo(element, targetPosition, duration) {
        let start = element.scrollTop;
        let distance = targetPosition - start;
        let startTime = null;

        function easeOutCubic(t) {
            return (--t) * t * t + 1;
        }

        function scrollAnimation(currentTime) {
            if (!startTime) {
                startTime = currentTime;
            }

            const elapsedTime = currentTime - startTime;
            const progress = Math.min(elapsedTime / duration, 1);

            // Update start and distance based on the current targetPosition
            start = element.scrollTop;
            distance = targetPosition - start;
            element.scrollTop = start + distance * easeOutCubic(progress);

            // Continue animation if not finished
            if (progress < 1) {
                requestAnimationFrame(scrollAnimation);
            }
        }
        requestAnimationFrame(scrollAnimation);
    }

    stop(){
        // this.videoPlayer.pause();
    }

    async update(attr){
        
        let provider = attr.provider;
        let videoId = attr.videoId;
        let newTranscript = attr.newTranscript;

        let transcriptWrapper = document.querySelector('.js-overlay-video .js-video-player__scroll');
        transcriptWrapper.innerHTML = '';
        let videoWrapper = document.querySelector('.js-overlay-video .js-video-player__wrap');
        videoWrapper.classList.remove('has-transcript');
        videoWrapper.classList.remove('is-transcript-active');
        
        if(newTranscript){
            if (this.videoPlayer.elements.wrapper.closest('.js-overlay-video') == null) return;
            transcriptWrapper.innerHTML = '';
            transcriptWrapper.appendChild(newTranscript);
            document.querySelector('.js-overlay-video .js-video-player__wrap').classList.add('has-transcript');

            let transcriptItems = transcriptWrapper.querySelectorAll('.js-video-transcript__item');
            // this.videoPlayer.on('timeupdate', event => {
            //     this.updateTranscription(event.detail.plyr.currentTime, transcriptItems, videoWrapper);
            // });
        }
        // console.log(this.videoPlayer);
        if (this.videoPlayer.elements.wrapper.closest('.js-overlay-video') == null) return;
        // this.videoPlayer.autoplay = true;
        // this.videoPlayer.source =  {
        //     type: 'video',
        //     sources: [
        //         {
        //         src: videoId,
        //         provider: provider,
        //         },
        //     ],
        // }
        
        // let thisWrapper = this.el.closest('.js-video-player__wrap');
        // if(thisWrapper.querySelectorAll('.js-video-player__transcript .js-video-transcript__item').length > 0){
        //     transcriptItems = thisWrapper.querySelectorAll('.js-video-player__transcript .js-video-transcript__item');
        //     this.videoPlayer.on('timeupdate', event => {
        //         this.updateTranscription(event.detail.plyr.currentTime, transcriptItems,thisWrapper);
        //     });
        // }
    } catch(error) {
        console.error('Error loading Plyr:', error);
    }

    pause(){
        // this.videoPlayer.pause();
        // console.log('pause');
    }


    destroyOverlay(updateEl = null){
        document.querySelector('.js-overlay-video').innerHTML = '';
        if (updateEl.getAttribute('data-overlay') != 'true' && updateEl != null) return;
        this.videoPlayer = null;
    }
}
